<template>
    <v-container fluid>
        <v-progress-linear
            indeterminate
            color="yellow darken-2"
            height="15"
            rounded
            v-if="paymentloaded == false"
        ></v-progress-linear>
        <div id="paymentform"></div>

        <v-row
            class="mb-6"
        >
            <v-col
                cols="12"
                offset-lg="2"
                lg="8"
                md="10"
                offset-md="1"
            >
                <v-card
                    elevation="6"
                    v-if="context.paymentrequest.division"
                >
                    <v-card-text v-if="context.paymentrequest.division.toString() == 'BPLO'">
                        <v-card-title>Payment Slip: {{ context.paymentrequest.paymentslip }}</v-card-title>

                        <v-row
                            dense
                        >
                            <v-col
                                cols="12"
                            >
                                <strong class="text-h6">Breakdown of Fees</strong>
                            </v-col>
                        </v-row>
                        
                        <template v-for="(feeparent, k) in context.paymentrequest.items">
                            <v-row
                                :key="`fee-year-container-${k}`"
                            >
                                <v-col
                                    cols="12"
                                    class="text-h4"
                                >
                                    {{ feeparent.Year }}
                                </v-col>
                            </v-row>

                            <template v-for="(fee, i) in feeparent.Fees">
                                <v-row
                                    :key="`fee-container-${k}-${i}`"
                                    dense
                                    v-if="parseFloat(fee.amount) > 0"
                                >
                                    <v-col
                                        cols="8"
                                    >
                                        <strong>{{ fee.feeType }}</strong>
                                    </v-col>
                                    <v-col
                                        cols="4"
                                    >
                                        &#8369;{{ Numeral(fee.amount) }}
                                    </v-col>
                                </v-row>
                            </template>
                        </template>

                        <v-row
                            dense
                        >
                            <v-col
                                cols="8"
                            >
                                <strong>Convenience Fee:</strong>
                            </v-col>
                            <v-col
                                cols="4"
                            >
                                &#8369;{{ Numeral(ConvenienceFee(altpaynet.reqs.amount)) }}
                            </v-col>
                        </v-row>

                        <v-row
                            dense
                            style="border-top: 2px double #000;"
                        >
                            <v-col
                                cols="8"
                            >
                                <strong>Amount to Pay:</strong>
                            </v-col>
                            <v-col
                                cols="4"
                            >
                                &#8369;{{ Numeral(altpaynet.reqs.amount + conveniencefee) }}
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-text v-else-if="context.paymentrequest.division.toString() == 'RPTCLEARANCE'">
                        <v-card-title>TDN: {{ altpaynet.reqs.others.tdns }}</v-card-title>
                        <v-card-subtitle>Number of copies: {{ altpaynet.reqs.others.numcopies }}</v-card-subtitle>

                        <v-card-subtitle>Breakdown of Fees</v-card-subtitle>

                        <v-row
                            dense
                        >
                            <template v-for="(fee, i) in Object.keys(context.paymentrequest.items)">
                                <v-col
                                    cols="9"
                                    :key="`rptclearance-fee-label-${i}`"
                                >
                                    <strong>{{ fee }}</strong>
                                </v-col>

                                <v-col
                                    cols="3"
                                    :key="`rptclearance-fee-value-${i}`"
                                >
                                    &#8369;{{ Numeral(context.paymentrequest.items[fee]) }}
                                </v-col>
                            </template>
                        </v-row>

                        <v-row
                            dense
                        >
                            <v-col
                                cols="9"
                            >
                                <strong>Convenience Fee:</strong>
                            </v-col>
                            <v-col
                                cols="3"
                            >
                                &#8369;{{ Numeral(ConvenienceFee(GrandTotal_RTPClearance(context.paymentrequest.items))) }}
                            </v-col>
                        </v-row>

                        <v-row
                            dense
                            class="mt-6"
                        >
                            <v-col
                                cols="9"
                                style="border-top: 2px solid #000;"
                            >
                                <strong>Grand Total:</strong>
                            </v-col>
                            <v-col
                                cols="3"
                                style="border-top: 2px solid #000;"
                            >
                                &#8369;{{ Numeral(GrandTotal_RTPClearance(context.paymentrequest.items) + conveniencefee) }}
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-text v-else-if="context.paymentrequest.division.toString() == 'RPT'">
                        <v-card-title>Assessment #: {{ context.paymentrequest.paymentslip }}</v-card-title>

                        <v-card-subtitle>Breakdown of Fees</v-card-subtitle>
                        <template v-for="(fee, i) in context.paymentrequest.items">
                            <v-row
                                dense
                                :key="`rpt-fee-container-${i}`"
                                v-if="FullAdvanced(fee, context.paymentrequest.paymentduration)"
                            >
                                <v-col
                                    cols="12"
                                >
                                    <strong>Year: {{ fee.Year }}</strong>
                                </v-col>
                                <v-col
                                    cols="9"
                                >
                                    <strong>Basic Tax</strong>
                                </v-col>
                                <v-col
                                    cols="3"
                                >
                                    &#8369;{{ Numeral(fee.BasicTax) }}
                                </v-col>

                                <v-col
                                    cols="9"
                                    v-if="parseFloat(fee.BasicDiscount) !== 0"
                                >
                                    <strong>Basic Discount</strong>
                                </v-col>
                                <v-col
                                    cols="3"
                                    v-if="parseFloat(fee.BasicDiscount) !== 0"
                                >
                                    &#8369;{{ Numeral(fee.BasicDiscount) }}
                                </v-col>

                                <v-col
                                    cols="9"
                                    v-if="parseFloat(fee.BasicPenalty) !== 0"
                                >
                                    <strong>Basic Penalty</strong>
                                </v-col>
                                <v-col
                                    cols="3"
                                    v-if="parseFloat(fee.BasicPenalty) !== 0"
                                >
                                    &#8369;{{ Numeral(fee.BasicPenalty) }}
                                </v-col>

                                <v-col
                                    cols="9"
                                >
                                    <strong>SEF</strong>
                                </v-col>
                                <v-col
                                    cols="3"
                                >
                                    &#8369;{{ Numeral(fee.SEF) }}
                                </v-col>

                                <v-col
                                    cols="9"
                                    v-if="parseFloat(fee.SEFDiscount) !== 0"
                                >
                                    <strong>SEF Discount</strong>
                                </v-col>
                                <v-col
                                    cols="3"
                                    v-if="parseFloat(fee.SEFDiscount) !== 0"
                                >
                                    &#8369;{{ Numeral(fee.SEFDiscount) }}
                                </v-col>

                                <v-col
                                    cols="9"
                                    v-if="parseFloat(fee.SEFPenalty) !== 0"
                                >
                                    <strong>SEF Penalty</strong>
                                </v-col>
                                <v-col
                                    cols="3"
                                    v-if="parseFloat(fee.SEFPenalty) !== 0"
                                >
                                    &#8369;{{ Numeral(fee.SEFPenalty) }}
                                </v-col>

                                <v-col
                                    cols="9"
                                    style="border-top: 2px solid #000;"
                                >
                                    <strong>Total:</strong>
                                </v-col>
                                <v-col
                                    cols="3"
                                    style="border-top: 2px solid #000;"
                                >
                                    &#8369;{{ Numeral(fee.Total) }}
                                </v-col>
                            </v-row>
                        </template>

                        <v-row
                            dense
                        >
                            <v-col
                                cols="9"
                            >
                                <strong>Convenience Fee:</strong>
                            </v-col>
                            <v-col
                                cols="3"
                            >
                                &#8369;{{ Numeral(ConvenienceFee(GrandTotal(context.paymentrequest.items, context.paymentrequest.paymentduration))) }}
                            </v-col>
                        </v-row>

                        <v-row
                            dense
                            class="mt-6"
                        >
                            <v-col
                                cols="9"
                                style="border-top: 2px solid #000;"
                            >
                                <strong>Grand Total:</strong>
                            </v-col>
                            <v-col
                                cols="3"
                                style="border-top: 2px solid #000;"
                            >
                                &#8369;{{ Numeral(GrandTotal(context.paymentrequest.items, context.paymentrequest.paymentduration) + conveniencefee) }}
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-text v-else-if="context.paymentrequest.division.toString() == 'CHISS' && context.paymentrequest.others">
                        <!-- CHISS -->
                        <v-card-title>
                            {{ context.paymentrequest.others.service_code }} ({{ context.paymentrequest.paymentslip }})
                        </v-card-title>
                        <v-card-subtitle>
                            <p class="mx-0 px-0 my-0 py-0">
                                {{ context.paymentrequest.others.description }}
                            </p>
                        </v-card-subtitle>

                        <template v-for="(feename, k) in Object.keys(context.paymentrequest.items)">
                            <v-row
                                :key="`fee-container-${k}`"
                                dense
                            >
                                <v-col
                                    cols="9"
                                >
                                    <strong>{{ feename }}</strong>
                                </v-col>
                                <v-col
                                    cols="3"
                                >
                                    &#8369;{{ Numeral(context.paymentrequest.items[feename]) }}
                                </v-col>
                            </v-row>
                        </template>

                        <v-row
                            dense
                        >
                            <v-col
                                cols="9"
                            >
                                <strong>Convenience Fee:</strong>
                            </v-col>
                            <v-col
                                cols="3"
                            >
                                &#8369;{{ Numeral(ConvenienceFee(GrandTotal(Object.keys(context.paymentrequest.items).map(x => {
                                    return {
                                        Total: parseFloat(context.paymentrequest.items[x]),
                                        Year: 1999,
                                    }
                                }), 'Advanced'))) }}
                            </v-col>
                        </v-row>

                        <v-row
                            dense
                            class="mt-6"
                        >
                            <v-col
                                cols="9"
                                style="border-top: 2px solid #000;"
                            >
                                <strong>Grand Total:</strong>
                            </v-col>
                            <v-col
                                cols="3"
                                style="border-top: 2px solid #000;"
                            >
                                &#8369;{{ Numeral(GrandTotal(Object.keys(context.paymentrequest.items).map(x => {
                                    return {
                                        Total: parseFloat(context.paymentrequest.items[x]),
                                        Year: 1999,
                                    }
                                }), 'Advanced') + conveniencefee) }}
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- <v-col
                cols="12"
                offset-lg="2"
                lg="8"
                md="10"
                offset-md="1"
            >
                <v-select
                    :items="localforeigncardtypes"
                    item-text="text"
                    item-value="value"
                    label="Issued Card Type"
                    v-model="localforeigncard"
                ></v-select>
            </v-col>

            <v-col
                cols="12"
                offset-lg="2"
                lg="8"
                md="10"
                offset-md="1"
            >
                <v-text-field
                    v-model="issuingbank"
                    label="Name of Issuing Bank"
                ></v-text-field>
            </v-col> -->
        </v-row>

        <!-- <form :action="altpaynet.url.receiver" class="paymentWidgets" data-brands="AMEX VISA VISADEBIT MAESTRO MASTER MASTERDEBIT"></form> -->
        <form :action="altpaynet.url.receiver" class="paymentWidgets" data-brands="VISA VISADEBIT MASTER MASTERDEBIT"></form>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import numeral from "numeral"
import { State, interpret } from "xstate"
import { toggleMachine } from "../states/toggle"
import moment from "moment"

export default {
    name: 'payment_test',
    props: ['CheckIfLoggedInInternal'],
    metaInfo: {
        title: 'Digital Tuguegarao - Payment Test',
    },
    data() {
        return {
            conveniencefee: 0,
            overlay: false,
            altpaynet: {
                url: {
                    receiver: ``,
                    form: ``,
                },
                reqs: {
                    amount: 0,
                    givenName: '',
                    surname: '',
                    street1: '',
                    street2: '',
                    city: '',
                    state: '',
                    postcode: '',
                    email: '',
                    country: 'PH',
                    merchantTransactionId: 'Test001',
                    testMode: 'EXTERNAL',
                    cart: [],
                    division: '',
                    duration: '',
                }
            },
            citizen: {},
            paymentloaded: false,
            requestid: '',
            toggleService: interpret(toggleMachine),
            current: toggleMachine.initialState,
            context: toggleMachine.context,
            localforeigncardtypes: [{
                text: 'Local',
                value: 'Local',
            }, {
                text: 'Foreign',
                value: 'Foreign',
            }],
            localforeigncard: 'Local',
            issuingbank: '',
        }
    },
    methods: {
        GrandTotal_RTPClearance(pr) {
            let total = 0

            Object.keys(pr).forEach(x => {
                total += parseFloat(pr[x])
            })

            return total
        },
        NationlinkCF(total) {
            let cf = 50

            if(total > 2500 && total <= 7500) {
                cf = 75
            } else if(total > 7500 && total <= 15000) {
                cf = 100
            } else if(total > 15000 && total <= 30000) {
                cf = 150
            } else if(total > 30000 && total <= 50000) {
                cf = 290
            } else if(total > 50000 && total <= 80000) {
                cf = 460
            } else if(total > 80000 && total <= 120000) {
                cf = 650
            } else if(total > 120000 && total <= 175000) {
                cf = 915
            } else if(total > 175000 && total <= 210000) {
                cf = 1100
            } else if(total > 210000 && total <= 400000) {
                cf = 2100
            } else if(total > 400000) {
                cf = 3000
            }

            return cf
        },
        ConvenienceFee(total = 0) {
            // console.log(this.context.paymentrequest.prepayment)
            // const cffee = (total * 0.035) + 70

            // this.conveniencefee = cffee

            // return cffee
            let cffee = 0

            switch(this.context.paymentrequest.prepayment.paymentoption.toString()) {
                case 'National':
                    if(this.context.paymentrequest.prepayment.debitcredit.toString() == 'Debit'){
                        // 2% for debit
                        this.context.paymentrequest.prepayment.bankcharges = total * 0.02
                    } else{
                        // 4% for credit
                        this.context.paymentrequest.prepayment.bankcharges = total * 0.04
                    }
                    break;
                case 'International':
                    if(this.context.paymentrequest.prepayment.debitcredit.toString() == 'Debit'){
                        // 2% for debit
                        this.context.paymentrequest.prepayment.bankcharges = total * 0.02
                    } else{
                        // 4% for credit
                        this.context.paymentrequest.prepayment.bankcharges = total * 0.04
                    }
                    break;
                case 'Fortune Pay':
                    // cffee = (total * 0.035) + 70
                    this.context.paymentrequest.prepayment.bankcharges = total * 0.035
                    break;
            }
            
            this.context.paymentrequest.prepayment.nationlinkcharges = this.NationlinkCF(total)
            // const cffee = (total * 0.035) + 70
            cffee = this.context.paymentrequest.prepayment.bankcharges + this.context.paymentrequest.prepayment.nationlinkcharges

            this.conveniencefee = cffee

            return cffee
        },
        FullAdvanced(fee, terms) {
            return terms.toString() == 'Advanced' ? true : parseInt(fee.Year) <= parseInt(moment().format('YYYY'))
        },
        GrandTotal(pr, terms) {
            let total = 0

            // console.log(pr)

            pr.forEach(x => {
                if(terms.toString() == 'Advanced' || parseInt(x.Year) <= parseInt(moment().format('YYYY'))){
                    total += parseFloat(x.Total)
                }
            })

            return total
        },
        Numeral(num) {
            return numeral(parseFloat(num)).format('0,0.00')
        },
        paymentform() {
            axios({
                method: `post`,
                url: this.altpaynet.url.form,
                data: {
                    requirements: JSON.stringify(this.altpaynet.reqs),
                    prepayment: JSON.stringify(this.context.paymentrequest.prepayment),
                    conveniencefee: this.conveniencefee,
                    requestid: this.requestid.toString(),
                }
            })
                .then(response => {
                    // console.log(response)

                    if(response.data.result.code.toString() == '000.200.100'){
                        let _script = document.createElement( 'script' )
						_script.setAttribute( 'src', 'https://oppwa.com/v1/paymentWidgets.js?checkoutId=' + response.data.id )
                        _script.setAttribute( 'async', true )
                        // _script.onload = () => {
                        //     var elementCheckingInt = setInterval(() => {
                        //         if(document.querySelector("input[name='bankAccount.bankName']")){
                        //             document.querySelector("input[name='bankAccount.bankName']").value = this.context.paymentrequest.prepayment.nameofissuingbank.toString()

                        //             document.querySelector("select[name='customParameters[SHOPPER_bankIssuedCardType]']").value = this.context.paymentrequest.prepayment.paymentoption.toString()

                        //             clearInterval(elementCheckingInt)
                        //         }
                        //     }, 1000)
                        // }
                        document.getElementById('paymentform').append( _script )

                        this.paymentloaded = true
                    } else{
                        this.$emit('snackbar', {
                            variant: 'red darken-2',
                            message: 'Failed loading Payment Form, refresh this page to try again.'
                        })
                    }
                })
                .catch(() => {
                    this.$emit('snackbar', {
                        variant: 'red darken-2',
                        message: 'Failed loading Payment Form, refresh this page to try again.'
                    })
                })
        },
        paymentrequest() {
            this.overlay = true

            axios({
                method: 'post',
                url: `${this.domain}/op_payment_request`,
                data: {
                    id: this.requestid.toString(),
                }
            })
                .then(response => {
                    this.overlay = false

                    if(response.data.response){
                        const requestdata = this.$jwt.decode(response.data.request, this.jwtsecret)

                        if(requestdata.request.amount && parseFloat(requestdata.request.amount) > 0){
                            this.altpaynet.reqs.amount = parseFloat(requestdata.request.amount.replace(/[^\d.]/g, ''))

                            this.altpaynet.url.receiver = `${this.localdomain}paymentstatus/${this.requestid}/`

                            switch(requestdata.request.division.toString()) {
                                case 'BPLO':
                                    // console.log(requestdata.request.items)

                                    // requestdata.request.items = requestdata.request.items.sort((a, b) => {
                                    //     return ('' + a.feeType.toString()).localeCompare(b.feeType.toString())
                                    // })
                                    break;
                            }

                            this.toggleService.send({
                                type: 'PAYMENTREQUEST',
                                paymentrequest: requestdata.request
                            })

                            // console.log(this.context)

                            this.altpaynet.reqs.division = requestdata.request.division
                            this.altpaynet.reqs.cart = requestdata.request.items
                            this.altpaynet.reqs.duration = requestdata.request.paymentduration || null
                            this.altpaynet.reqs.others = requestdata.request.others || null

                            // console.log(requestdata)

                            this.paymentform()
                        }
                    } else{
                        this.$emit('snackbar', {
                            variant: 'red darken-2',
                            message: response.data.message.toString(),
                        })
                    }
                })
                .catch(() => {
                    this.overlay = false
                })
        },
        LockPaymentRequest() {
            axios({
                method: 'post',
                url: `${this.domain}/op_lock_payment_request`,
                data: {
                    id: this.requestid.toString(),
                }
            })
                .then(response => {
                    console.log(response.data)
                })
        },
        UnlockPaymentRequest() {
            axios({
                method: 'post',
                url: `${this.domain}/op_unlock_payment_request`,
                data: {
                    id: this.requestid.toString(),
                }
            })
                .then(response => {
                    console.log(response.data)
                })
        }
    },
    mounted() {
        this.CheckIfLoggedInInternal()

        this.altpaynet.url = {
            receiver: `${this.localdomain}paymentstatus/`,
            form: `${this.domain}/altpaynetformreq`,
        }

        const { user } = this.$jwt.decode(this.$session.get('crmusersessionsignature'), this.jwtsecret)
        user.mobile = user.mobile || ''
        delete user.passwd
        delete user.signature

        this.citizen = _.cloneDeep(user)

        this.altpaynet.reqs.givenName = this.citizen.firstname.toString()
        this.altpaynet.reqs.surname = this.citizen.lastname.toString()
        
        if(this.citizen.address.present.istugue){
            this.altpaynet.reqs.street1 = this.citizen.address.present.street.toString()
            if(this.citizen.address.present.brgydetails){
                this.altpaynet.reqs.street2 = this.citizen.address.present.brgydetails.BarangayName.toString()
            }
        } else{
            this.altpaynet.reqs.street1 = this.citizen.address.present.address1.toString()
            this.altpaynet.reqs.street2 = this.citizen.address.present.address2.toString()
        }

        this.altpaynet.reqs.city = this.citizen.address.present.city.toString()
        this.altpaynet.reqs.state = this.citizen.address.present.province.toString()
        this.altpaynet.reqs.postcode = this.citizen.address.present.zipcode

        this.altpaynet.reqs.email = this.citizen.email.toString()

        // check
        this.CRM_Interval = setInterval(() => {
            if(!(this.$ls.get('isLoggedIn') && this.$session.exists() && this.$session.get('crmusersessionsignature'))){
                clearInterval(this.CRM_Interval)

                this.$router.push({
                    name: 'login'
                }).catch(()=>{})
            }
        }, 500)

        this.requestid = this.$route.params.requestid.toString()

        if(!this.requestid){
            this.$router.push({
                name: 'profile'
            }).catch(() => {})
        }

        this.paymentrequest()

        // lock the payment request
        this.LockPaymentRequest()

        window.onbeforeunload = () => {
            this.UnlockPaymentRequest()
        }

        // this.paymentform()
    },
    created() {
        const stateDefinition = JSON.parse(localStorage.getItem('app-xstate')) || toggleMachine.initialState

        const previousState = State.create(stateDefinition)

        const resolvedState = toggleMachine.resolveState(previousState)

        this.toggleService
            .onTransition(state => {
                this.current = state
                this.context = state.context

                localStorage.setItem('app-xstate', JSON.stringify(state))
            })
            .start(resolvedState)
    },
    beforeDestroy() {
        this.UnlockPaymentRequest()
    }
}
</script>